<template>
  <FormContainer withoutDivider>
    <template #title>Informations salarié(e)</template>
    <template #content>
      <div
        class="form__bloc"
        v-if="!readonly && saisieAdherent && false"
      >
        <RechercheSalarie
          mode="salaries"
          :id-demande="model!.id"
          @selected="onRechercheSalarie"
          class="col-12 col-sm-36"
          :readonly
        ></RechercheSalarie>
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_9"
          v-model="nomNaissanceModel"
          label="Nom de naissance"
          hint="50 caractères maximum"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :required="meta.salarie?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nomNaissance?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_10"
          v-model="nomUsageModel"
          label="Nom d'usage (si différent)"
          hint="50 caractères maximum"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :required="meta.salarie?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_11"
          v-model="prenomModel"
          label="Prénom (le premier selon l'état civil)"
          hint="50 caractères maximum"
          class="col-12 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :required="meta.salarie?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.prenom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_12"
          key="sexe-dropdown"
          v-model="sexeModel"
          label="Sexe"
          class="col-6 col-md-12 col-sm-36"
          :items="sexeItems"
          :readonly
          :required="meta.salarie?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.sexe?.$messageErreurDirty!"
        />
        <WrapperInputDate
          id="field_13"
          v-model="dateNaissanceModel"
          label="Date de naissance"
          :hint="HINT_DATE"
          class="col-6 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :required="meta.salarie?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.dateNaissance?.$messageErreurDirty!"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_14"
          v-model="nirTemporaireModel"
          label="Êtes-vous détenteur d'un NIR temporaire ?"
          :required="meta.salarie?.nirTemporaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nirTemporaire?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          help="Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale"
          class="col-12 col-sm-36"
        />
        <WrapperInput
          id="field_15"
          v-model="nirModel"
          :label="nirLabel"
          :hint="nirHint"
          class="col-12 col-sm-36"
          placeholder="Ex : 1234567890123"
          :required="meta.salarie?.nir?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nir?.$messageErreurDirty!"
          :maxlength="nirMaxLength"
          deletable
          :readonly
          :help="nirHelp"
        />
        <WrapperToggleSwitch
          id="field_16"
          v-model="handicapeModel"
          label="Qualité de travailleur handicapé"
          :items="OuiOuNon"
          :required="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.beneficieReconnaissanceTravailleurHandicape?.$messageErreurDirty!"
          :readonly
          class="col-12 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
  <FormContainer>
    <template #title>Informations complémentaires salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_23"
          v-model="cspModel"
          label="Catégorie socio-professionnelle (CSP)"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.Csp"
          :required="meta.salarie?.csp?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.csp?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="meta.salarie?.contratPacea?.$status !== PropertyStatus.NotPresent"
          id="field_24"
          v-model="paceaModel"
          label="Contrat PACEA ?"
          :required="meta.salarie?.contratPacea?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.contratPacea?.$messageErreurDirty!"
          help="Parcours d’accompagnement plus souple vers l’autonomie et l’emploi des jeunes en mission locale. La démarche d’accompagnement globale du travail temporaire (Mission Jeunes) vise à faciliter l’accès à l’emploi et à la qualification des jeunes qui ont contractualisé un PACEA avec la mission locale."
          :items="OuiOuNon"
          :readonly
          class="col-12 col-sm-36"
        />
        <WrapperToggleSwitch
          v-else
          id="field_24"
          label="Contrat PACEA ?"
          :items="OuiOuNon"
          help="Parcours d’accompagnement plus souple vers l’autonomie et l’emploi des jeunes en mission locale. La démarche d’accompagnement globale du travail temporaire (Mission Jeunes) vise à faciliter l’accès à l’emploi et à la qualification des jeunes qui ont contractualisé un PACEA avec la mission locale."
          class="col-12 col-sm-36"
          disabled
        />
        <WrapperToggleSwitch
          v-if="meta.salarie?.contratEngagementJeune?.$status !== PropertyStatus.NotPresent"
          id="field_25"
          v-model="engagementJeuneModel"
          label="Contrat d’engagement Jeune (Mission locale) ?"
          :required="meta.salarie?.contratEngagementJeune?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.contratEngagementJeune?.$messageErreurDirty!"
          help="Dispositif d’accompagnement intensif vers l’emploi (15h à 20h par semaine) des jeunes en mission locale. La démarche d’accompagnement globale du travail temporaire (Mission Jeunes) qui vise à faciliter l’accès à l’emploi et à la qualification des jeunes qui ont signé un CEJ avec la mission locale."
          :items="OuiOuNon"
          :readonly
          class="col-12 col-sm-36"
        />
        <WrapperToggleSwitch
          v-else
          id="field_25"
          label="Contrat d’engagement Jeune (Mission locale) ?"
          help="Dispositif d’accompagnement intensif vers l’emploi (15h à 20h par semaine) des jeunes en mission locale. La démarche d’accompagnement globale du travail temporaire (Mission Jeunes) qui vise à faciliter l’accès à l’emploi et à la qualification des jeunes qui ont signé un CEJ avec la mission locale."
          :items="OuiOuNon"
          class="col-12 col-sm-36"
          disabled
        />
        <WrapperToggleSwitch
          id="field_26"
          v-model="inscritFranceTravailModel"
          label="Inscrit à France Travail ?"
          :required="meta.salarie?.inscritFranceTravail?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.inscritFranceTravail?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-12 col-sm-36"
        />
      </div>

      <div
        class="form__bloc"
        v-if="model?.sousDispositif === 'CDPI'"
      >
        <WrapperToggleSwitch
          id="field_27"
          v-model="justifieAncienneteModel"
          label="Justifie-t-il de 150h d'ancienneté au cours des 12 derniers mois ?"
          :required="meta.salarie?.justifieAncienneteInterim?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.justifieAncienneteInterim?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-14 col-md-14 col-sm-36"
        />
        <WrapperInput
          v-if="meta.salarie?.nombreHeuresAncienneteInterim?.$status !== PropertyStatus.NotPresent"
          id="field_28"
          v-model="nombreHeuresAncienneteModel"
          label="Nombre d'heures d'ancienneté en intérim"
          class="col-14 col-md-14 col-sm-36"
          :required="meta.salarie?.nombreHeuresAncienneteInterim?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.nombreHeuresAncienneteInterim?.$messageErreurDirty!"
          :readonly
          :maxlength="12"
        />
        <WrapperInput
          v-else
          id="field_28"
          label="Nombre d'heures d'ancienneté en intérim"
          class="col-14 col-md-14 col-sm-36"
          disabled
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          v-if="meta.salarie?.categoriePublic?.$status !== PropertyStatus.NotPresent"
          id="field_29"
          v-model="categoriePublicModel"
          label="Catégorie de public"
          :required="meta.salarie?.categoriePublic?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.categoriePublic?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lovCategoriePublic"
          :readonly
        />
        <WrapperDropdown
          v-else
          id="field_29"
          label="Catégorie de public"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_30"
          v-model="niveauEntreeFormationModel"
          label="Niveau d’entrée en formation"
          :required="meta.salarie?.niveauEntreeFormation?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.niveauEntreeFormation?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.NiveauEntreeFormation"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_31"
          v-model="diplomePlusEleveModel"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
          key-id="code"
          key-label="intitule"
        />
        <WrapperInput
          id="field_32"
          hint="50 caractères maximum"
          v-model="intituleDiplomeModel"
          label="Intitulé du diplôme"
          class="col-12 col-md-18 col-sm-36"
          :required="meta.salarie?.intituleDiplome?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.intituleDiplome?.$messageErreurDirty!"
          :readonly
          :maxlength="50"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    DEMANDE_STORE,
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_DATE_NAIS,
    PLACEHOLDER_NOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_PRENOM,
  } from '@/features/interface/demande/shared'
  import { objectIsEmpty, OuiOuNon, sexeItems } from '@/features/interface/shared/tools'
  import { CXPI_ACTIONS } from '@/features/interface/demande/cxpi/useDemandeCXPIActions.ts'
  import { RechercheSalarie } from '@/features/interface/demande/shared/components/salaries'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import type { SalarieRechercheDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { type DialogResult, useDialog } from '@/features/interface/dialog'
  import {
    categoriePublicCDPIItems,
    categoriePublicCIPIItems,
  } from '@/features/interface/demande/cxpi/dropdown-items.ts'
  import { noop } from '@/features/shared/tools'

  const { showDialog } = useDialog()

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey, setupFieldWithOptions } = store
  const { model, meta, lov, readonly, typeContextCourant } = storeToRefs(store)

  const { patchRemplacerSalarié } = inject(CXPI_ACTIONS)!
  const saisieAdherent = computed(() => typeContextCourant.value === TypesContextesAutorisesEnum.Adherent)

  const nirMaxLength = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? 40 : 13
  })

  const nirHint = computed(() => {
    return model.value?.salarie?.nirTemporaire === true ? '11 à 40 caractères' : '13 caractères'
  })

  const nirHelp = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? "Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale."
      : 'Le numéro de sécurité sociale est inscrit sur la carte vitale, en dessous du nom et du prénom du porteur.'
  })

  const nirLabel = computed(() => {
    return model.value?.salarie?.nirTemporaire === true
      ? 'Numéro technique temporaire'
      : 'Numéro de sécurité sociale (NIR)'
  })

  const nomNaissanceModel = setupFieldWithKey<string>('salarie.nomNaissance', true)
  const nomUsageModel = setupFieldWithKey<string>('salarie.nom', true)
  const prenomModel = setupFieldWithKey<string>('salarie.prenom', true)
  const nirTemporaireModel = setupFieldWithKey<boolean>('salarie.nirTemporaire', false)
  // TODO si l'option temporaire (NTT) est cochée, modifier le libellé du NIR par "N° technique temporaire"
  // NIR 13 ou 15, appel api si code commence pas par 3,4,7,8
  // clé de luhne 2 chiffre caractére 14 et 15 facultatif
  // appel api uniquement avec NIR
  // verifier donnée age/departement  etc, par rapport au NIR
  const nirModel = setupFieldWithKey<string>('salarie.nir', true)

  const dateNaissanceModel = setupFieldWithKey<string>('salarie.dateNaissance', true)
  const handicapeModel = setupFieldWithKey<boolean>('salarie.beneficieReconnaissanceTravailleurHandicape', false)
  const cspModel = setupFieldWithKey<string>('salarie.csp', false)
  // const paceaModel = setupFieldWithKey<string>('salarie.contratPacea', false)
  const paceaModel = setupFieldWithOptions<boolean | null>({
    withDebounce: false,
    getValue(model) {
      return model.salarie?.contratPacea ?? null
    },
    setPatch(patch, value) {
      patch.salarie!.contratPacea = value
      if (value)
        showDialog({
          title: 'Salarié en mission PACEA',
          message:
            'Vous avez sélectionné que le salarié est en mission PACEA, il sera nécessaire de transmettre la charte d’engagement mission jeune.',
          type: 'Ok',
          closable: true,
        }).catch(noop)
    },
  })
  const engagementJeuneModel = setupFieldWithOptions<boolean | null>({
    withDebounce: false,
    getValue(model) {
      return model.salarie?.contratEngagementJeune ?? null
    },
    setPatch(patch, value) {
      patch.salarie!.contratEngagementJeune = value
      if (value)
        showDialog({
          title: 'Contrat d’engagement jeune',
          message:
            'Vous avez sélectionné que le salarié est en contrat d’engagement jeune, il sera nécessaire de transmettre la charte d’engagement mission jeune.',
          type: 'Ok',
          closable: true,
        }).catch(noop)
    },
  }) //('salarie.contratEngagementJeune', false)
  const justifieAncienneteModel = setupFieldWithKey<string>('salarie.justifieAncienneteInterim', false)
  const nombreHeuresAncienneteModel = setupFieldWithKey<string>('salarie.nombreHeuresAncienneteInterim', false)
  const sexeModel = setupFieldWithKey<string>('salarie.sexe', false)
  const inscritFranceTravailModel = setupFieldWithKey<boolean>('salarie.inscritFranceTravail', false)

  const categoriePublicModel = setupFieldWithKey<boolean>('salarie.categoriePublic', false)
  const niveauEntreeFormationModel = setupFieldWithKey<boolean>('salarie.niveauEntreeFormation', false)

  const diplomePlusEleveModel = setupFieldWithKey<string>('salarie.diplomeOuTitreLePlusEleveObtenu', false)
  const intituleDiplomeModel = setupFieldWithKey<string>('salarie.intituleDiplome', false)

  const onRechercheSalarie = async (value: SalarieRechercheDTO) => {
    let reponse: DialogResult = 'Ok'

    if (objectIsEmpty(model.value?.salarie, { exclude: ['source'] }) === false) {
      const dialog = useDialog()
      reponse = await dialog.showDialog({
        message: ['Cette opération entrainera le remplacement de la saisie existante.', "Confirmez-vous l'opération ?"],
        type: 'OkCancel',
        closable: true,
        title: 'Attention',
      })
    }
    if (reponse === 'Ok') {
      patchRemplacerSalarié(value)
    }
  }

  const lovCategoriePublic = computed(() => {
    return model.value!.sousDispositif === 'CDPI' ? categoriePublicCDPIItems : categoriePublicCIPIItems
  })

  watch(handicapeModel, (newValue, oldValue) => {
    if (!newValue) return
    if (newValue === oldValue) return
    showDialog({
      type: 'Ok',
      closable: true,
      title: 'Travailleur handicapé',
      message: `Vous avez sélectionné que le salarié est travailleur
                  handicapé, il sera donc nécessaire de transmettre le
                  formulaire de la reconnaissance travailleur handicapé (RQTH)`,
    })
  })
</script>
